import { EuiSelectable } from '@equipmentshare/ds2'
import FilterPopover from '../FilterPopover'
import styles from './filters.module.css'

export type Filter = {
  key: string,
  label: string,
  initialValue: boolean,
}

export type FilterOption = {
	key: string,
	label: string,
	checked?: 'on' | 'off',
}

export type FilterState = FilterOption[];

export type FilterChange = ( args: { filter: string, value: boolean } ) => void

export type FilterProps = {
	filterState: FilterState,
	setFilterState: ( fs: FilterState ) => void,
	numFilters?: number,
	numActiveFilters?: number,
	onFilterChange?: FilterChange,
	label?: string,
	isLoading?: boolean,
}

export function getFilterDifference( oldFilterState: FilterState, newFilterState: FilterState ): { filter: string, value: boolean } | undefined {
	for ( const oldOption of oldFilterState ) {
		const newOption = newFilterState.find( ( n ) => oldOption.key === n.key )

		if ( newOption && newOption.checked !== oldOption.checked ) {
			return {
				filter: newOption.key,
				value: newOption.checked === 'on',
			}
		}
	}

	return undefined
}

export default function Filters( { filterState, setFilterState, numFilters, numActiveFilters, onFilterChange, label, isLoading }: FilterProps ) {
	const handleFilterChange = ( newFilterState: FilterState ) => {
		if ( onFilterChange ) {
			const filterDifference = getFilterDifference( filterState, newFilterState )

			if ( filterDifference ) {
				onFilterChange( filterDifference )
			}
		}
		setFilterState( newFilterState )
	}
	const hasActiveFilters = numActiveFilters !== undefined && numActiveFilters > 0
	return (
		<FilterPopover
			label={label ?? 'Filters'}
			numFilters={numFilters}
			numActiveFilters={numActiveFilters}
			hasActiveFilters={hasActiveFilters}
			isLoading={isLoading}
		>
			<EuiSelectable
				options={filterState}
				onChange={handleFilterChange}
				className={styles.selectable}
			>
				{ ( list ) => list }
			</EuiSelectable>
		</FilterPopover>
	)
}
